import React, { Component, Fragment } from "react";
import _ from "lodash";
import "./style.css";
import { SignatureImageImproved } from "../../components/Reports/utils/SignatureImage";

function getFormattedValue(row, col) {
  const { accessor, dontJoinValues, formatter } = col;
  let val = null;
  if (typeof accessor === "string") {
    val = getColVal(row, accessor);
  } else if (Array.isArray(accessor)) {
    val = accessor.map((acc) => getColVal(row, acc));
    if (!dontJoinValues) {
      val = val.join(" ");
    }
  }
  if (formatter) {
    val = formatter(val);
  }
  return val === null || val === undefined ? "" : val;
}

function getBlueCardCertifyValue(row, col) {
  const { accessor } = col;

  let val = null;

  if (typeof accessor === "string") {
    if (accessor.includes("blueCardCertify")) {
      val = getColVal(row, accessor);
    }
  } else if (Array.isArray(accessor)) {
    for (const acc of accessor) {
      if (acc.includes("blueCardCertify")) {
        const tempVal = getColVal(row, acc);
        if (tempVal !== null && tempVal !== undefined && tempVal !== "") {
          val = tempVal;
          break;
        }
      }
    }
  }

  if (!val) return null;
  if (val.certify) return "certify";
  if (val.pendingCertify) return "pendingCertify";
  return null;
}
function getFormOverridesProps(rowData, col) {
  const { accessor } = col;
  let bindingAccessor = col.bindingAccessor;
  const formOverrideData = rowData.formOverrides;
  let formOverridesValues = formOverrideAccessorValuesProcessor(accessor, formOverrideData);
  let bindingFormOverrideValues = formOverrideAccessorValuesProcessor(bindingAccessor, formOverrideData);

  /**
   * @param {boolean} disable field visibility
   */
  let formOverrideProps = {
    disable: false,
  };
  //binding case, overrides the latter
  if (bindingFormOverrideValues) {
    formOverridePropsProcessor(bindingFormOverrideValues, formOverrideProps);
    return formOverrideProps;
  }
  //normal case
  formOverridePropsProcessor(formOverridesValues, formOverrideProps);
  return formOverrideProps;
}
function formOverrideAccessorValuesProcessor(accessor, formOverrideData) {
  let formOverridesValues = null;
  if (typeof accessor === "string") {
    formOverridesValues = [getColVal(formOverrideData, accessor)];
  } else if (Array.isArray(accessor)) {
    formOverridesValues = accessor.map((acc) => getColVal(formOverrideData, acc));
  }

  return formOverridesValues;
}

function formOverridePropsProcessor(formOverridesValues, formOverrideProps) {
  if (!formOverridesValues) return;
  let formOverrideValueObj = formOverridesValues.find((obj) => obj.value || obj.accessible);
  if (formOverrideValueObj) return;
  let formOverrideObj = formOverridesValues.find((obj) => Object.keys(obj).length > 0 && obj.accessible === false);
  if (!formOverrideObj) return;
  formOverrideProps.disable = true;
}

function setColValue(dataRow, col, val) {
  const { accessor } = col;
  if (typeof accessor === "string") {
    var parts = accessor.split(".");
    // todo: implement for length > 1 later
    if (parts.length === 1) {
      let acc = parts[0];
      if (dataRow.hasOwnProperty(acc)) {
        dataRow[acc] = val;
      }
    }
  }
}

function getColVal(obj, accessor) {
  var parts = accessor.split(".");

  if (obj) {
    for (var i = 0; i < parts.length; i++) {
      obj = obj[parts[i]];
      if (obj === undefined || obj === null) {
        break;
      }
    }
  }
  return obj ? obj : "";
}

// function getTableHeaderDepth(columns, depth = 1) {
//   let nextlevel = 0;
//   columns.forEach((col) => {
//     if (col.columns && col.columns.length > 0) {
//       nextlevel = getTableHeaderDepth(col.columns);
//     }
//   });
//   return depth + nextlevel;
// }

function getDataRowSchema(columns) {
  return columns
    .map((col) => {
      return col.columns && col.columns.length > 0 ? getDataRowSchema(col.columns) : [col];
    })
    .flat();
}

function addMinimumRows(rows, minRowsCount, rowSchema) {
  let requiredRows = [...rows];
  let missingRowsCount = minRowsCount - rows.length;
  if (missingRowsCount > 0) {
    requiredRows = [...requiredRows, ...Array.from({ length: missingRowsCount }, (v, i) => ({}))];
  }
  return requiredRows.map((dataRow) => {
    let maxSubRows = null;
    rowSchema &&
      rowSchema.forEach((col) => {
        const { isArray, minDataRowsCount } = col;
        let val = getFormattedValue(dataRow, col);
        if (!Array.isArray(val)) val = [];
        if (isArray) {
          // add missing rows
          val = addMinimumRows(val, minDataRowsCount, rowSchema.columns);
          setColValue(dataRow, col, val);
          if (maxSubRows) {
            maxSubRows = Math.max(maxSubRows, val.length);
          } else {
            maxSubRows = val.length;
          }
        }
      });
    dataRow.maxSubRows = maxSubRows ? maxSubRows : 1;

    return dataRow;
  });
}
/**
 * RenderReportTableData
 * Takes parameters like rowSchema, rows, and minRowsCount.
 * Generates table rows data below the header area.
 * Handles nested row structures, array data, and sub-rows.
 * Uses additional helper functions like addMinimumRows, getFormattedValue, getColVal, and Array.from.*/
const RenderReportTableData = (rowSchema, rows, minRowsCount) => {
  let requiredRows = addMinimumRows(rows, minRowsCount, rowSchema);

  return requiredRows.map((row, row_i) => {
    const { maxSubRows } = row;
    return (
      <Fragment key={row_i}>
        <tr>
          {rowSchema.map((col, i) => {
            const { dataFontSize, isArray, subAccessor, dataClassName } = col;
            let val = getFormattedValue(row, col);
            if (isArray) {
              let subRows = [...val];
              let subRow1 = subRows[0];
              val = getColVal(subRow1, subAccessor);
            }

            return (
              // for array data, set it to one by default
              <td key={i} colSpan={col.colSpan} rowSpan={isArray ? 1 : maxSubRows} style={{ position: "relative" }}>
                <span
                  className={`${dataClassName ? dataClassName : ""}`}
                  style={_.merge({ wordBreak: "break-word" }, dataFontSize ? { fontSize: dataFontSize } : {})}
                >
                  {val}
                </span>
              </td>
            );
          })}
        </tr>
        {Array.from({ length: maxSubRows - 1 }, (v, subRowIndex) => {
          return (
            <tr key={`${row_i}_${subRowIndex}`}>
              {rowSchema
                .filter((col) => col.isArray)
                .map((col, i) => {
                  const { dataFontSize, subAccessor, dataClassName } = col;
                  let val = getFormattedValue(row, col);
                  let subRows = [...val];
                  let subRow = subRows[subRowIndex + 1];
                  val = getColVal(subRow, subAccessor);

                  return (
                    // for array data, set it to one by default
                    <td key={i} colSpan={col.colSpan}>
                      <span
                        className={`${dataClassName ? dataClassName : ""}`}
                        style={_.merge({ wordBreak: "break-word" }, dataFontSize ? { fontSize: dataFontSize } : {})}
                      >
                        {val}
                      </span>
                    </td>
                  );
                })}
            </tr>
          );
        })}
      </Fragment>
    );
  });
};
/**
 * ReportTableSectionRenderer:
 * Takes parameters like rowsData and section.
 * Renders the entire table section including header and data rows.
 * Handles inline data rendering separately.
 * Uses the functions RenderInlineReportTable, RenderReportTableHeader, and RenderReportTableData.
 */

const RenderInlineReportTable = (columns, heights, classes, inlineStyle, data) => {
  if (columns.length === 0) return null;

  let height = heights.header1;
  let className = classes && classes.header1 ? classes.header1 : "";
  let style = inlineStyle && inlineStyle.header1 ? inlineStyle.header1 : {};
  let hasBlueCardCertify = null;

  for (let i = 0; i < columns.length; i++) {
    hasBlueCardCertify = getBlueCardCertifyValue(data, columns[i]);
    if (hasBlueCardCertify) break;
  }

  return (
    <tr
      className={`${className} ${hasBlueCardCertify === "certify" ? "tr-certify" : ""} ${
        hasBlueCardCertify === "pendingCertify" ? "tr-pending-certify" : ""
      }`}
      style={_.merge({ height: height }, style)}
    >
      {columns.map((col, i) => {
        const {
          titleFormatter,
          title,
          isTitleOnly,
          isValueOnly,
          leftAlign,
          topAlign,
          Signature,
          valueOnNextLine,
          unBold,
          rightAlign,
          centerAlign,
          disable,
        } = col;
        let formOverridesProps = getFormOverridesProps(data, col);
        return (
          <th
            key={i}
            className={`tbl-bordered-header ${leftAlign ? "text-left pd-left-5px" : ""} ${topAlign ? "text-top pd-top-5px" : ""} ${
              rightAlign ? "text-right pd-right-5px" : ""
            }  ${unBold ? "text-unBold" : ""}  ${disable || formOverridesProps.disable ? "tr-disable" : ""}`}
            colSpan={col.colSpan}
            rowSpan={col.rowSpan}
            style={col.style ? col.style : {}}
          >
            {formOverridesProps.disable ? null : (
              <React.Fragment>
                {isValueOnly || formOverridesProps.disable ? null : (
                  <span className={`${col.className}`}>
                    {titleFormatter ? titleFormatter(title) : title}
                    {isTitleOnly ? null : ":"}
                  </span>
                )}
                {valueOnNextLine && <br></br>}
                {isTitleOnly || formOverridesProps.disable ? null : Signature ? (
                  <span className="pd-left-10px">
                    <SignatureImageImproved signatureImage={getFormattedValue(data, col)} />
                  </span>
                ) : (
                  <span
                    className={`${valueOnNextLine || centerAlign ? "text-left" : "text-left pd-left-10px"}`}
                    style={{ fontWeight: 100 }}
                  >
                    {getFormattedValue(data, col)}
                  </span>
                )}
              </React.Fragment>
            )}
          </th>
        );
      })}
    </tr>
  );
};
/**
 * RenderReportTableHeader
 * Takes parameters like columns, heights, classes, and inlineStyle.
 * Generates the header area with columns.
 * Handles nested column structures.
 * Renders header rows with specified heights, classes, and inline styles.
 */
const RenderReportTableHeader = (columns, heights, classes, inlineStyle) => {
  if (columns.length === 0) return null;

  let renderedheaders = [];

  {
    let height = heights.header1;
    let className = classes && classes.header1 ? classes.header1 : "";
    let style = inlineStyle && inlineStyle.header1 ? inlineStyle.header1 : {};
    let renderedCols = columns.map((col, i) => {
      const { titleFormatter, title, leftAlign, topAlign } = col;
      return (
        <th
          key={i}
          className={`tbl-bordered-header ${leftAlign ? "text-left pd-left-5px" : ""} ${topAlign ? "text-top pd-top-5px" : ""}`}
          colSpan={col.colSpan}
          rowSpan={col.rowSpan}
        >
          <span className={`${col.className}`}>{titleFormatter ? titleFormatter(title) : title}</span>
        </th>
      );
    });
    if (renderedCols.length > 0) {
      renderedheaders.push({
        height: height,
        renderedCols: renderedCols,
        className: className,
        inlineStyle: style,
      });
    }
  }
  {
    let height = heights.header2;
    let className = classes && classes.header2 ? classes.header2 : "";
    let style = inlineStyle && inlineStyle.header2 ? inlineStyle.header2 : {};
    let renderedCols = columns
      .reduce((resultColumns, col) => {
        if (col.columns && col.columns.length > 0) {
          resultColumns.push(...col.columns);
        }
        return resultColumns;
      }, [])
      .map((col, i) => {
        const { titleFormatter, title, leftAlign } = col;
        return (
          <th
            key={i}
            className={`tbl-bordered-header ${leftAlign ? "text-left pd-left-5px" : ""}`}
            colSpan={col.colSpan}
            rowSpan={col.rowSpan}
          >
            <span className={`${col.className}`}>{titleFormatter ? titleFormatter(title) : title}</span>
          </th>
        );
      })
      .filter((col) => col);
    if (renderedCols.length > 0) {
      renderedheaders.push({
        height: height,
        renderedCols: renderedCols,
        className: className,
        inlineStyle: style,
      });
    }
  }

  return renderedheaders.length > 0
    ? renderedheaders.map((header, i) => (
        <tr key={i} className={header.className} style={_.merge({ height: header.height }, header.inlineStyle)}>
          {header.renderedCols}
        </tr>
      ))
    : null;
};

const ReportTableSectionRenderer = (props) => {
  let { rowsData, section } = props;
  const { columns, heights, classes, inlineStyle, minDataRowsCount, inlineData, headerOnly, inlineBodyData, onlyBody } = section;

  let rowsDataSchema = getDataRowSchema(columns);
  return (
    <Fragment>
      {inlineData ? (
        <Fragment>
          <thead>{RenderInlineReportTable(columns, heights, classes, inlineStyle, rowsData ? rowsData : {})}</thead>
        </Fragment>
      ) : inlineBodyData ? (
        <Fragment>{RenderInlineReportTable(columns, heights, classes, inlineStyle, rowsData ? rowsData : {})}</Fragment>
      ) : (
        <Fragment>
          {onlyBody ? null : <thead>{RenderReportTableHeader(columns, heights, classes, inlineStyle)}</thead>}
          {headerOnly ? null : (
            <tbody>{RenderReportTableData(rowsDataSchema, Array.isArray(rowsData) ? rowsData : [], minDataRowsCount)}</tbody>
          )}
        </Fragment>
      )}
    </Fragment>
  );
};

export default ReportTableSectionRenderer;



// WEBPACK FOOTER //
// ./src/libraries/ReportGenerator/index.jsx